import * as ToggleGroup from "@radix-ui/react-toggle-group";
import { STATUS_IDS, ThreeStatesToggle } from "../../../constants/common";
import { getRequestInfoStatusBgColor } from "../../../lib/functions";
import { cn } from "../../../utils/cn";
import React from "react";

interface ThreeStateToggleProps {
  states: ThreeStatesToggle[];
  value?: STATUS_IDS;
  onChange: (val: string) => void;
  disabled?: boolean;
}

const ThreeStateToggle = ({
  states,
  value,
  onChange,
  disabled = false,
}: ThreeStateToggleProps) => {
  const handleChange = (val: string) => {
    if (val && val !== STATUS_IDS.SELECT.toString()) {
      onChange(val);
    }
  };

  return (
    <ToggleGroup.Root
      type="single"
      value={value?.toString()}
      onValueChange={handleChange}
      disabled={disabled}
      className="inline-flex items-center bg-gray-200 rounded-full p-1"
    >
      {states.map((item: ThreeStatesToggle) => {
        return (
          <ToggleGroup.Item
            key={item.title}
            value={item.value.toString()}
            className={cn(
              "text-xs px-2 py-1 rounded-full transition-colors duration-200 disabled:cursor-not-allowed",
              value === item.value
                ? `${getRequestInfoStatusBgColor(
                    item.value.toString()
                  )} text-white shadow`
                : "text-gray-600 hover:bg-gray-300"
            )}
          >
            {item.title}
          </ToggleGroup.Item>
        );
      })}
    </ToggleGroup.Root>
  );
};

export default React.memo(ThreeStateToggle);
